import {
  EOrderStatusFlow,
  OrderStatusTypes,
} from 'src/app/domain/enums/order-status-types.enum';

export const tabMappingsInbound = {
  'Pendente análise': {
    statusFlow: EOrderStatusFlow.PROCESSING,
    statusFlowRequest: `flow=${EOrderStatusFlow.PROCESSING}`,
    tableTitle: 'Ordens pendentes análise',
    displayedColumns: [
      'id',
      'paymentDate',
      'companyName',
      'cnpj',
      'amount',
      'orderSource',
      'tipoPessoa',
      'action',
    ],
    filters: ['id', 'currency', 'createdDate', 'document', 'name', 'slipCode'],
    columnWidths: {},
  }, 
  'Aguardando cotação': {
    statusFlow: EOrderStatusFlow.AVAILABLE_QUOTATION,
    statusFlowRequest: `flow=${EOrderStatusFlow.AVAILABLE_QUOTATION}`,
    tableTitle: 'Ordens pendentes cotação pelo cliente',
    displayedColumns: [
      'id',
      'paymentDate',
      'companyName',
      'cnpj',
      'amount',
      'orderSource',
      'tipoPessoa',
    ],
    filters: ['id', 'currency', 'createdDate', 'document', 'name', 'slipCode'],
    columnWidths: {},
  },
  'Prontas para liquidação': {
    statusFlow: EOrderStatusFlow.IDENTIFIED_PAYMENT,
    statusFlowRequest: `flow=${EOrderStatusFlow.AVAILABLE_PAYMENT}&flow=${EOrderStatusFlow.IDENTIFYING_PAYMENT}&flow=${EOrderStatusFlow.IDENTIFIED_PAYMENT}`,
    tableTitle: 'Ordens com o câmbio fechado',
    displayedColumns: [
      'id',
      'clientInfo',
      'amount',
      'amountMN',
      'orderSource',
      'tipoPessoa',
      'status',
      'action',
    ],
    filters: ['id', 'currency', 'createdDate', 'document', 'name', 'slipCode'],
    columnWidths: {},
  },
  'Ordens com pendência': {
    statusFlow: EOrderStatusFlow.PAYMENT_REPROVED,
    statusFlowRequest: `flow=${EOrderStatusFlow.PAYMENT_REPROVED}&flow=${EOrderStatusFlow.PENDING_PAYMENT_INFORMATION}&flow=${EOrderStatusFlow.IDENTIFIED_PAYMENT_ABROAD}`,
    tableTitle: 'Ordens com pendências',
    displayedColumns: [
      'id',
      'companyName',
      'cnpj',
      'amount',
      'orderSource',
      'tipoPessoa',
      'reasonRefusalPayment',
      'action',
    ],
    filters: ['id', 'currency', 'document', 'name', 'value', 'pendencyType'],
    columnWidths: {},
  },
  'Aguardando pagamento': {
    statusFlow: EOrderStatusFlow.IDENTIFYING_PAYMENT_ABROAD,
    statusFlowRequest: `flow=${EOrderStatusFlow.IDENTIFYING_PAYMENT_ABROAD}`,
    tableTitle: 'Ordens aguardando pagamento no exterior',
    displayedColumns: [
      'id',
      'createdDate',
      'companyName',
      'cnpj',
      'amount',
      'orderSource',
      'tipoPessoa',
      'action',
    ],
    filters: ['id', 'currency', 'createdDate', 'document', 'name', 'slipCode'],
    columnWidths: {},
  },
};

export const tabMappingsOutbound = {
  'Pendente análise': {
    statusFlow: EOrderStatusFlow.PROCESSING,
    statusFlowRequest: `flow=${EOrderStatusFlow.PROCESSING}`,
    tableTitle: 'Ordens pendentes análise',
    displayedColumns: ['id', 'clientInfo', 'createdDate', 'amount', 'action'],
    filters: ['createdDate', 'currency', 'value'],
    columnWidths: {
      id: '20%',
      clientInfo: '35%',
      createdDate: '15%',
      amount: '20%',
      action: '10%',
    },
  },
  'Ordens cotadas': {
    statusFlow: EOrderStatusFlow.AVAILABLE_PAYMENT,
    statusFlowRequest: `flow=${EOrderStatusFlow.AVAILABLE_PAYMENT}&flow=${EOrderStatusFlow.IDENTIFYING_PAYMENT}&confirmationSlip=false`,
    tableTitle: 'Ordens com o câmbio fechado',
    displayedColumns: [
      'id',
      'clientInfo',
      'agency',
      'sendOption',
      'amount',
      'spread',
      'settlementFlowTreasury',
      'status',
      'action',
    ],
    filters: ['agency', 'sendOption', 'currency', 'value', 'settlementFlow', 'confirmationTreasury'],
    columnWidths: {
      id: '8%',
      clientInfo: '20%',
      agency: '8%',
      sendOption: '10%',
      amount: '13%',
      spread: '10%',
      settlementFlowTreasury: '8%',
      status: '13%',
      action: '8%',
    },
  },
  Boletagem: {
    statusFlow: EOrderStatusFlow.AVAILABLE_PAYMENT,
    statusFlowRequest: `flow=${EOrderStatusFlow.AVAILABLE_PAYMENT}&flow=${EOrderStatusFlow.IDENTIFYING_PAYMENT}&confirmationTreasury=true&confirmationSlip=false&showStatus=true`,
    tableTitle: 'Ordens prontas para boletar',
    displayedColumns: [
      'id',
      'clientInfo',
      'agency',
      'createdDate',
      'bankCurrencyTreasury',
      'amount',
      'levelingRateTreasury',
      'settlementFlowTreasury',
      'accountStatus',
      'action',
    ],
    filters: [
      'agency',
      'createdDate',
      'currency',
      'value',
      'bankCurrencyTreasury',
      'levelingRateTreasury',
      'settlementFlow',
    ],
    columnWidths: {
      id: '8%',
      clientInfo: '17%',
      agency: '8%',
      createdDate: '10%',
      bankCurrencyTreasury: '10%',
      amount: '10%',
      levelingRateTreasury: '8%',
      settlementFlowTreasury: '8%',
      accountStatus: '12%',
      action: '8%',
    },
  },
  Efetivação: {
    statusFlow: EOrderStatusFlow.IDENTIFYING_PAYMENT,
    statusFlowRequest: `flow=${EOrderStatusFlow.AVAILABLE_PAYMENT}&flow=${EOrderStatusFlow.IDENTIFYING_PAYMENT}&confirmationTreasury=true&confirmationSlip=true&effected=false`,
    tableTitle: 'Ordens em efetivação',
    displayedColumns: [
      'id',
      'clientInfo',
      'agency',
      'createdDate',
      'bankCurrencyTreasury',
      'amount',
      'levelingRateTreasury',
      'settlementFlowTreasury',
      'slipCode',
      'action',
    ],
    filters: [
      'agency',
      'createdDate',
      'currency',
      'value',
      'bankCurrencyTreasury',
      'levelingRateTreasury',
      'settlementFlow',
    ],
    columnWidths: {
      id: '8%',
      clientInfo: '17%',
      agency: '8%',
      createdDate: '10%',
      bankCurrencyTreasury: '10%',
      amount: '10%',
      levelingRateTreasury: '8%',
      settlementFlowTreasury: '8%',
      slipCode: '13%',
      action: '8%',
    },
  },
  Confirmação: {
    statusFlow: EOrderStatusFlow.IDENTIFIED_PAYMENT,
    statusFlowRequest: `flow=${EOrderStatusFlow.AVAILABLE_PAYMENT}&flow=${EOrderStatusFlow.IDENTIFYING_PAYMENT}&confirmationTreasury=true&confirmationSlip=true&effected=true`,
    tableTitle: 'Ordens em confirmação',
    displayedColumns: [
      'select',
      'id',
      'clientInfo',
      'agency',
      'createdDate',
      'bankCurrencyTreasury',
      'amount',
      'amountMN',
      'slipCode',
      'action',
    ],
    filters: [
      'agency',
      'createdDate',
      'currency',
      'value',
      'bankCurrencyTreasury',
      'levelingRateTreasury',
      'slipCode',
    ],
    columnWidths: {
      select: '60px',
      id: '8%',
      clientInfo: '17%',
      agency: '8%',
      createdDate: '10%',
      bankCurrencyTreasury: '10%',
      amount: '10%',
      amountMN: '11%',
      slipCode: '12%',
      action: '8%',
    },
  },
  Liquidação: {
    statusFlow: EOrderStatusFlow.IDENTIFIED_PAYMENT,
    statusFlowRequest: `flow=${EOrderStatusFlow.IDENTIFIED_PAYMENT}`,
    tableTitle: 'Ordens prontas para liquidar',
    displayedColumns: [
      'id',
      'clientInfo',
      'agency',
      'createdDate',
      'bankCurrencyTreasury',
      'amount',
      'slipCode',
      'action',
    ],
    filters: [
      'agency',
      'createdDate',
      'bankCurrencyTreasury',
      'currency',
      'value',
    ],
    columnWidths: {
      id: '8%',
      clientInfo: '25%',
      agency: '10%',
      createdDate: '12%',
      bankCurrencyTreasury: '12%',
      amount: '12%',
      slipCode: '12%',
      action: '8%',
    },
  },
  'Ordens com pendência': {
    statusFlow: EOrderStatusFlow.PAYMENT_REPROVED,
    statusFlowRequest: `flow=${EOrderStatusFlow.PAYMENT_REPROVED}&flow=${EOrderStatusFlow.PENDING_INVOICE_ATTACHMENT}&flow=${EOrderStatusFlow.PENDING_ORDER_INFORMATION}&flow=${EOrderStatusFlow.AVAILABLE_QUOTATION}`,
    tableTitle: 'Ordens pendentes',
    displayedColumns: [
      'id',
      'clientInfo',
      'createdDate',
      'bankCurrencyTreasury',
      'amount',
      'orderSource',
      'reasonRefusalPayment',
    ],
    filters: ['createdDate', 'currency', 'value', 'pendencyType'],
    columnWidths: {
      id: '8%',
      clientInfo: '23%',
      agency: '10%',
      createdDate: '13%',
      bankCurrencyTreasury: '13%',
      amount: '10%',
      orderSource: '13%',
      reasonRefusalPayment: '15%',
    },
  },
};

export const columnWidthsDefault: Record<string, string> = {
  select: '50px',
  id: '8%',
  reasonRefusalPayment: '20%',
  companyName: '18%',
  createdDate: '10%',
  paymentDate: '10%',
  amount: '13%',
  amountMN: '11%',
  clientInfo: '19%',
  tipoPessoa: '9%',
  orderSource: '10%',
  cnpj: '16%',
  accountStatus: '13%',
  bankCurrencyTreasury: '10%',
  action: '8%',
  slipCode: '11%',
  agency: '8%',
  sendOption: '10%',
  spread: '8%',
  levelingRateTreasury: '8%',
  settlementFlowTreasury: '10%',
  status: '15%',
};

export const tabMappingsHistoryAdmin = {
  'Todas as ordens': {
    statusFlow: '',
    statusFlowRequest: ``,
    statusRequest: ``,
    tableTitle: 'Todas as ordens',
    displayedColumns: [
      'id',
      'clientInfo',
      'createdDate',
      'amount',
      'orderSource',
      'status',
      'slipCode',
      'action',
    ],
  },
  'Em andamento': {
    statusFlow: EOrderStatusFlow.PROCESSING,
    statusFlowRequest: `flow=${EOrderStatusFlow.PROCESSING}`,
    statusRequest: `status=${OrderStatusTypes.AVAILABLE}&status=${OrderStatusTypes.PENDING}`,
    tableTitle: 'Ordens em andamento',
    displayedColumns: [
      'id',
      'clientInfo',
      'createdDate',
      'amount',
      'orderSource',
      'status',
      'slipCode',
      'action',
    ],
  },
  Finalizadas: {
    statusFlow: EOrderStatusFlow.PAID,
    statusFlowRequest: `flow=${EOrderStatusFlow.PAID}`,
    statusRequest: `status=${OrderStatusTypes.ACCOMPLISHED}`,
    tableTitle: 'Ordens finalizadas',
    displayedColumns: [
      'id',
      'clientInfo',
      'createdDate',
      'amount',
      'orderSource',
      'status',
      'slipCode',
      'action',
    ],
  },
};
